module.exports = __webpack_public_path__ + "static/media/background_4.838edf6f.mp3";